export default function handlePushNotifications() {}
export async function registerForPushNotificationsAsync() {}